import Record from "./base"

export class Review extends Record {
  constructor(...args) {
    super(...args)
    const [model, props] = args
  }
}
